angular.module("workStatus.components", []).component("workStatus", {
    templateUrl: "ng/components/workStatus/workStatus.view.html",
    bindings: {
        model: "=",
        financialModel: "=",
        canEditPreventive: "=",
        navigator: '=',
        isMonitorPratiche: '<'
    },
    controllerAs: "workStatuseCtrl",
    controller: function WorkStatus(
        FinancialModel,
        $workflowService,
        $configService,
        $download
    ) {

        var self = this;
        var type = "WF_DIGITAL";

        self.$onInit = function () {
            self.showRestrictedFiles = $configService.getAppConfig().allFunctionalities.includes("DOC_RISERVATI")
            console.log("model work status", self.model);
            console.log("financialModel work status", self.financialModel)
            self.listOfHeight = [];
            self.supportModel = {
                loaderButtonModifica: false
            }

        };

        self.modifica = function () {
            self.supportModel.loaderButtonModifica = true;

            $workflowService.resumeInstance(self.financialModel.idWfInstance, type, "modifica")
                .then(function (response) {
                    response.idWfInstance = self.financialModel.idWfInstance
                    console.log(self.navigator);
                    self.navigator.enabled.enabledBack = !response.frontEndOptions.disabledBack;
                    self.navigator.enabled.enabledSave = !response.frontEndOptions.disabledSave;
                    self.financialModel.viewIndex = response.viewIndex;
                    self.financialModel = FinancialModel.build(response)
                    self.supportModel.loaderButtonModifica = false;
                })
                .catch(function (error) {
                    console.log("error", error);
                    self.supportModel.loaderButtonModifica = false;
                })

        }

        self.downloadFile = function (file) {
            // return $configService.getUrl() +
            //     "/uni/downloadGenericDigital/service-infos/FINANCIAL_DEROGHE/" +
            //     encodeURIComponent(file.cdDoc) +
            //     "/" +
            //     encodeURIComponent(file.id) +
            //     "/" +
            //     encodeURIComponent(self.financialModel.idWfInstance) +
            //     "/?token=" +
            //     $configService.getAppConfig().token;
            var url = "/uni/downloadDocDigital/service-infos/"
            var input = {
                downloadKey: file.downloadKey
            }
            $download.getGenericDownload(url, input)
                .then(function (response) {
                    console.log(response)
                })

        }

        self.getHeight = function (text) {
            if (self.isMonitorPratiche && text) {
                var tempTextArea = angular.element("<textarea></textarea>");
                tempTextArea.css("visibility", "hidden");
                tempTextArea.css("white-space", "pre-wrap");
                tempTextArea.val(text);
                angular.element("body").append(tempTextArea);
                var height = (tempTextArea[0].scrollHeight);
                tempTextArea.remove();
                return height + "px";
            } else {
                return;
            }
        };
    }
});